/* eslint-disable import/prefer-default-export */
export const ACTIONS = {
  UPDATE: 'UPDATE_PAGE_FLOW',
  CLEAR: 'CLEAR_PAGE_FLOW',
};
